import { ArrowClockwise, CloudSlash, WarningCircle } from '@phosphor-icons/react'
import { errorMessage } from '../api/client'

export function PageLoader({ label = 'Načítám…' }: { label?: string }) {
  return (
    <div className="state-panel" role="status" aria-live="polite">
      <span className="spinner" aria-hidden="true" />
      <p>{label}</p>
    </div>
  )
}

export function ErrorState({ error, onRetry }: { error: unknown; onRetry?: () => void }) {
  return (
    <div className="state-panel state-panel--error" role="alert">
      <WarningCircle size={28} weight="duotone" />
      <div>
        <strong>Tohle se nepodařilo načíst</strong>
        <p>{errorMessage(error)}</p>
      </div>
      {onRetry && (
        <button type="button" className="button button--quiet" onClick={onRetry}>
          <ArrowClockwise size={18} /> Zkusit znovu
        </button>
      )}
    </div>
  )
}

export function EmptyState({ title, text }: { title: string; text: string }) {
  return (
    <div className="state-panel state-panel--empty">
      <CloudSlash size={28} weight="duotone" />
      <div>
        <strong>{title}</strong>
        <p>{text}</p>
      </div>
    </div>
  )
}

export function SaveState({ pending, saved }: { pending: boolean; saved?: boolean }) {
  return (
    <span className="save-state" aria-live="polite">
      {pending ? 'Ukládám…' : saved ? 'Uloženo' : ''}
    </span>
  )
}